import React, { useMemo } from "react";
import { AppLanguage, getCurrentLanguage, setLanguage, useTranslation } from "locales";
import { BaseMenuItemInterface } from "types";
import BaseIcon from "components/BaseIcon";
import BaseMenu from "components/BaseMenu";
import "./style.scss";

interface Props {
  className?: string;
}

function LanguageSwitcher({ className = "" }: Props) {
  // Subscribe to language changes — re-renders when i18next.changeLanguage() fires.
  useTranslation();
  const current = getCurrentLanguage();

  const items: BaseMenuItemInterface[] = useMemo(
    () => [
      { name: "ru", title: "Русский" },
      { name: "en", title: "English" },
    ],
    []
  );

  const onClick = (name: string) => {
    if (name === "ru" || name === "en") {
      setLanguage(name as AppLanguage);
    }
  };

  const cls = ["language-switcher", className].filter(Boolean).join(" ");

  return (
    <BaseMenu className={cls} itemsList={items} onClick={onClick}>
      <div className="language-switcher__activator">
        <span className="language-switcher__code">{current.toUpperCase()}</span>
        <BaseIcon size={10}>fas-angle-down</BaseIcon>
      </div>
    </BaseMenu>
  );
}

export default LanguageSwitcher;
